// extracted by mini-css-extract-plugin
export var border = "video-module--border--90033";
export var button = "video-module--button--8f179";
export var container = "video-module--container--4f70b";
export var embed = "video-module--embed--fd2f5";
export var graphic = "video-module--graphic--b44c7";
export var link = "video-module--link--76c93";
export var optional = "video-module--optional--65bd7";
export var text = "video-module--text--de52c";
export var thumbnail = "video-module--thumbnail--c49ec";